import { render, staticRenderFns } from "./card-video-slider.vue?vue&type=template&id=4a7b82d4&scoped=true&"
import script from "./card-video-slider.vue?vue&type=script&lang=js&"
export * from "./card-video-slider.vue?vue&type=script&lang=js&"
import style0 from "./card-video-slider.vue?vue&type=style&index=0&id=4a7b82d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b82d4",
  null
  
)

export default component.exports